const pageInfo = {
  sort: {
    sorted: false,
    unsorted: true,
    empty: true,
  },
  offset: 0,
  pageNumber: 0,
  pageSize: 10,
  paged: true,
  unpaged: false,
};

const coursesTotalActions = {
  VIEWS: 0,
  IMPRESSION: 0,
  INTERACTION: 0,
  RECOMMENDATION: 0,
};

const bannersTotalActions = {
  VIEWS: 0,
  IMPRESSION: 0,
  INTERACTION: 0,
};

const INITIAL_STATE = {
  coursesTotalActions,
  coursesTotalActionsError: false,
  courseAnalyticsError: false,
  isLoading: true,
  isLoadingcourseAnalytics: true,
  courseAnalytics: [],
  courseAnalyticsPageInfo: pageInfo,
  courseAnalyticsTotal: 0,

  bannerAnalytics: [],
  bannersTotalActions,
  bannersTotalActionsError: false,
  bannerAnalyticsError: false,
  isLoadingBanners: true,
  isLoadingBannerUsers: true,
  bannerAnalyticsPageInfo: pageInfo,
  bannerAnalyticsTotal: 0,

  courseLanguageCounts: {
    pt: 0,
    en: 0,
  },
  courseProfileCounts: { EXHIBITOR: 0 },
  bannerLanguageCounts: {
    pt: 0,
    en: 0,
  },
  bannerProfileCounts: { EXHIBITOR: 0 },

  impressionError: null,
  viewError: null,
  interactionError: null,

  courses: [],
  lessons: [],
  events: [],
  banners: [],
  years: [],

  eventsInfo: [],
  isLoadingInfo: true,

  courseError: false,
  eventsError: false,
  bannersError: false,
};

const analytics = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_COURSES_TOTAL_ACTIONS":
      return { ...state, isLoading: true };
    case "GET_COURSE_ANALYTICS":
      return { ...state, isLoadingcourseAnalytics: true };

    case "GET_COURSES_TOTAL_ACTIONS_SUCCESS":
      return {
        ...state,
        isLoading: false,
        coursesTotalActions: {
          ...state.coursesTotalActions,
          ...action.payload.params.actions,
        },
      };
    case "GET_COURSES_TOTAL_ACTIONS_FAIL":
      return {
        ...state,
        isLoading: false,
        coursesTotalActionsError: true,
        coursesTotalActions,
      };

    case "GET_COURSE_ANALYTICS_SUCCESS":
      return {
        ...state,
        courseAnalytics: payload.courseAnalytics,
        courseAnalyticsPageInfo: payload.pageInfo,
        courseAnalyticsTotal: payload.total,
        courseLanguageCounts: payload.languageCounts,
        courseProfileCounts: payload.profileCounts,
        isLoadingcourseAnalytics: false,
      };
    case "GET_COURSE_ANALYTICS_FAIL":
      return {
        ...state,
        courseAnalytics: [],
        courseAnalyticsPageInfo: pageInfo,
        courseAnalyticsTotal: 0,
        courseAnalyticsError: true,
        isLoadingcourseAnalytics: false,
      };

    case "GET_BANNERS_TOTAL_ACTIONS":
      return { ...state, isLoadingBanner: true };
    case "GET_BANNER_ANALYTICS":
      return { ...state, isLoadingBannerUsers: true };

    case "GET_BANNERS_TOTAL_ACTIONS_SUCCESS":
      return {
        ...state,
        isLoadingBanners: false,
        bannersTotalActions: {
          ...state.bannersTotalActions,
          ...action.payload.params.actions,
        },
      };
    case "GET_BANNERS_TOTAL_ACTIONS_FAIL":
      return {
        ...state,
        isLoadingBanners: false,
        bannersTotalActionsError: true,
        bannersTotalActions,
      };

    case "GET_BANNER_ANALYTICS_SUCCESS":
      return {
        ...state,
        bannerAnalytics: payload.bannerAnalytics,
        bannerAnalyticsPageInfo: payload.pageInfo,
        bannerAnalyticsTotal: payload.total,
        bannerLanguageCounts: payload.languageCounts,
        bannerProfileCounts: payload.profileCounts,
        isLoadingBannerUsers: false,
      };
    case "GET_BANNER_ANALYTICS_FAIL":
      return {
        ...state,
        bannerAnalytics: [],
        bannerAnalyticsPageInfo: pageInfo,
        bannerAnalyticsTotal: 0,
        bannerAnalyticsError: true,
        isLoadingBannerUsers: false,
      };

    case "CLEAR_COURSE_ANALYTICS":
      return {
        ...state,
        courseAnalytics: [],
        courseAnalyticsPageInfo: pageInfo,
        courseAnalyticsTotal: 0,
        courseAnalyticsError: false,
        courseLanguageCounts: { pt: 0, en: 0 },
        courseProfileCounts: { EXHIBITOR: 0 },
        coursesTotalActions,
        coursesTotalActionsError: false,
        isLoading: false,
        isLoadingcourseAnalytics: false,
      };

    case "CLEAR_BANNER_ANALYTICS":
      return {
        ...state,
        bannerAnalytics: [],
        bannerAnalyticsPageInfo: pageInfo,
        bannerAnalyticsTotal: 0,
        bannerAnalyticsError: false,
        bannerLanguageCounts: { pt: 0, en: 0 },
        bannerProfileCounts: { EXHIBITOR: 0 },
        bannersTotalActions,
        bannersTotalActionsError: false,
        isLoadingBanners: false,
        isLoadingBannerUsers: false,
      };

    case "GET_EVENT_LIST_ANALYTICS":
      return {
        ...state,
        eventsError: false,
        courses: [],
        lessons: [],
        isLoadingInfo: true,
      };
    case "GET_EVENT_LIST_ANALYTICS_SUCCESS":
      return {
        ...state,
        eventsError: false,
        events: action.payload.events,
        years: action.payload.years,
        eventsInfo: action.payload.eventsInfo,
        isLoadingInfo: false,
      };
    case "GET_EVENT_LIST_ANALYTICS_FAILURE":
      return {
        ...state,
        eventsError: true,
        events: [],
        years: [],
        eventsInfo: [],
        isLoadingInfo: false,
      };

    case "GET_COURSES_ANALYTICS":
    case "GET_LESSONS_ANALYTICS":
      return { ...state, courseError: false };

    case "GET_LESSONS_ANALYTICS_SUCCESS":
      return {
        ...state,
        courseError: false,
        lessons: action.payload.lessons,
      };

    case "GET_LESSONS_ANALYTICS_FAILURE":
      return {
        ...state,
        courseError: true,
        lessons: [],
      };

    case "GET_COURSES_ANALYTICS_SUCCESS":
      return {
        ...state,
        courseError: false,
        courses: action.payload.courses,
      };
    case "GET_COURSES_ANALYTICS_FAILURE":
      return {
        ...state,
        courseError: true,
        courses: [],
        lessons: [],
      };

    case "GET_BANNERS_LIST":
      return { ...state, bannersError: false };
    case "GET_BANNERS_LIST_SUCCESS":
      return {
        ...state,
        bannersError: false,
        banners: action.payload.banners,
      };
    case "GET_BANNERS_LIST_FAILURE":
      return {
        ...state,
        bannersError: true,
        banners: [],
      };

    default:
      return state;
  }
};

export default analytics;
